import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  list ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnMethods/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnMethods/findById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnMethods/deleteById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveOrUpdate ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnMethods/saveOrUpdate`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updatePushStatus ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnMethods/updatePushStatus`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDataInfomation ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnMethods/getDataInfomation`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
